/**
 * Created by vladislav on 17.09.2020
 */

const StarsProgressBar = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.options = options;

        const location = cleverapps.meta.getSelectedLocation();

        this.current = this.options.current !== undefined ? this.options.current : location.getStage();
        this.stars = this.options.stars !== undefined ? this.options.stars : location.getProgress() - cleverapps.pendingRewards.get("locationProgress");

        const styles = cleverapps.styles.StarsProgressBar;

        this.setAnchorPoint(0.5, 0.5);

        this.setContentSize2(this.options.width, styles.bar.height);

        this.addProgressBar();

        if (this.options.withPresent) {
            this.addPresent();
        }

        location.on("updateProgress", () => {
            this.setStars(location.getProgress() - cleverapps.pendingRewards.get("locationProgress"));
        });

        this.setStars(this.stars);
    },

    addProgressBar: function () {
        const styles = cleverapps.styles.StarsProgressBar.bar;

        const progressBar = this.bar = new ScaledProgressBar({
            background: bundles.progress_bar.frames.bg_simple,
            progress: bundles.progress_bar.frames.bar_simple,
            barText: {
                font: cleverapps.styles.FONTS.STARS_PROGRESS_BAR_TEXT,
                text: "[[%from%/%to%",
                icons: {
                    "[[": bundles.simple.frames.star_png
                },
                dy: styles.dy
            }
        });
        progressBar.setLength(this.options.width + 2 * styles.offsetX);
        progressBar.setPercentage(0);
        progressBar.setAlignment(this.width / 2, this.height / 2);

        this.addChild(this.bar);
        progressBar.background.setLocalZOrder(-10);
    },

    addPresent: function () {
        const styles = cleverapps.styles.StarsProgressBar;

        this.present = new cleverapps.Spine(bundles.simple.jsons.present_json);
        this.addChild(this.present);
        this.present.setScale(styles.present.scale);
        this.present.setSkin(styles.present.skin);
        this.present.setAnimation(0, styles.present.animation, true);
        this.present.setAlignment(styles.present);
        this.present.setLocalZOrder(10);

        cleverapps.tooltipManager.create(this.present, {
            text: Messages.get("OpenBackgroundTooltip"),
            rewards: cleverapps.meta.getSelectedLocation().calcReward(false, this.current),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            size: styles.present.tooltip
        });
    },

    setStars: function (stars) {
        this.stars = stars;

        this.bar.setGoal(SimpleLocation.GetRequiredProgress(this.current));
        this.bar.setPercentage(stars);
    },

    updateProgress: function () {
        const location = cleverapps.meta.getSelectedLocation();

        this.stars = location.getProgress() - cleverapps.pendingRewards.get("locationProgress");

        this.bar.setGoal(SimpleLocation.GetRequiredProgress(this.current));
        this.bar.setPercentage(this.stars, {
            animated: true
        });
    },

    animateToFull: function (callback) {
        const goal = SimpleLocation.GetRequiredProgress(this.current);
        this.bar.setGoal(goal);
        this.bar.setPercentage(goal, {
            animated: true,
            callback
        });
    },

    receivePrize: function (callback, source) {
        source = source || this.present;

        const rewards = cleverapps.meta.getSelectedLocation().calcReward(true, this.current);

        if (!rewards.length) {
            if (callback) {
                callback();
            }
            return;
        }

        const onComplete = callback ? cleverapps.wait(rewards.length, callback) : undefined;

        rewards.forEach((rewardItem) => {
            const reward = new Reward(rewardItem.type, rewardItem.value, { event: cleverapps.EVENTS.EARN.SIMPLE_REWARD });
            reward.receiveReward();
            reward.collectRewardsAnimation(source, {
                flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
                callback: onComplete,
                spawnHaptic: "reward.spawn",
                landHaptic: "reward.land",
                collectHaptic: "reward.collect"
            });
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STARS_PROGRESS_BAR_TEXT: {
        name: "default",
        size: 40
    }
});

cleverapps.styles.StarsProgressBar = {
    bar: {
        offsetX: 15,
        height: 80,
        dy: 4
    },

    present: {
        scale: 0.7,
        x: { align: "right", dx: 90 },
        y: { align: "center", dy: 5 },
        skin: "green",
        animation: "animation"
    }
};